import "jquery-ui/ui/widgets/draggable";

import $ from "jquery";

export default class PopupUtil {
  public static initialize(): void {
    this.resetDraggable();
  }

  private static resetDraggable(): void {
    window.setTimeout(() => this.resetDraggable(), 500);

    $(".layerpop_header")
      .css({ cursor: "move" })
      .on("mousedown", function (this: any) {
        const $this = $(this);
        //@ts-ignore
        $this.parent().draggable({
          stop: function (this: any) {
            const $this = $(this);

            const offset = $this.offset();
            //@ts-ignore
            offset.left = Math.max(offset.left, 0);
             //@ts-ignore
            offset.top = Math.max(offset.top, 0);
            //@ts-ignore
            offset.left = Math.min(offset.left, $this.parent().width() - $this.width());
            //@ts-ignore
            offset.top = Math.min(offset.top, $this.parent().height() - $this.height());
            //@ts-ignore
            $this.offset(offset);

            window.setTimeout(() => {
               //@ts-ignore
              if ($this.draggable("instance") != null) {
                 //@ts-ignore
                $this.draggable("destroy");
              }
            });
          },
        });
      })
      .on("mouseup", function (this: any) {
        const $this = $(this);

        window.setTimeout(() => {
           //@ts-ignore
          if ($this.parent().draggable("instance") != null) {
             //@ts-ignore
            $this.parent().draggable("destroy");
          }
        });
      });
  }
}
